import { Box, Button, Theme, Tooltip, Typography } from '@material-ui/core'
import { TransferenciaListModel } from 'model/api/gestao/transferencia/transferencia-list-model';
import { EnumStatusTransferencia } from 'model/enums/enum-status-transferencia';
import { useMemo, useState } from 'react';
import { useThemeQueries } from 'views/theme';
import { useStyles } from './info-transferencia-styles';
import { StatusTransferenciaMock } from 'data/mocks/status-transacao-mock';
import classNames from 'classnames';
import { toCurrency } from 'utils/toCurrency';
import { ExpandIcon } from 'views/components/icons';

const statusTransferencia = (situacao: EnumStatusTransferencia, theme: Theme): string => {
    switch (situacao) {
        case EnumStatusTransferencia.Aceito:
            return theme.palette.success.light;
        case EnumStatusTransferencia.Abortada:
            return theme.palette.error.light;
        case EnumStatusTransferencia.ErroInterno:
            return theme.palette.error.main;
        case EnumStatusTransferencia.Autorizada:
            return theme.palette.success.main;
        case EnumStatusTransferencia.Pendente:
            return theme.palette.warning.light;
        case EnumStatusTransferencia.Rejeitada:
            return theme.palette.error.dark;
        case EnumStatusTransferencia.ProcessandoEstorno:
            return theme.palette.info.main;
        case EnumStatusTransferencia.Estornada:
            return theme.palette.warning.dark;
        case EnumStatusTransferencia.Expirada:
            return theme.palette.warning.main;
        default:
            return theme.palette.info.light;
    }
}

interface InfoTransferenciaProps {
    transferencias: TransferenciaListModel[];
}

export const InfoTransferencias = ({ transferencias
}: InfoTransferenciaProps) => {
    const { isMobile, theme } = useThemeQueries();
    const [hide, setHide] = useState<boolean>(isMobile);

    const classes = useStyles({
        hide
    });

    const returnStatusInfo = useMemo(() => {
        const items: JSX.Element[] = StatusTransferenciaMock.filter(status => status.Key !== EnumStatusTransferencia.Todos).map((status) => {
            const transferenciaStatus = transferencias.filter(transferencia => transferencia.status === status.Key)

            const valorTotal = transferenciaStatus.reduce<number>((prev, curr) => prev + curr.valorPagamento, 0)
            const count = transferenciaStatus.length
            return (
                <Box className={classes.itemInfo}>
                    <Tooltip arrow title={status.Value} placement="right">
                        <Box
                            bgcolor={statusTransferencia(status.Key, theme)}
                            className={classNames(classes.tagStatus)}
                        ></Box>
                    </Tooltip>
                    <Box className={classes.textContainer}>
                        <Typography variant='caption' color='textSecondary'>
                            {status.Value}s: <span className={classes.textValor}>{count}</span>
                        </Typography>
                        <Typography variant='caption' color='textSecondary'>
                            <span className={classes.textValor}>{toCurrency(valorTotal)}</span>
                        </Typography>
                    </Box>
                </Box>
            )
        })

        return items
    }, [classes.itemInfo, classes.tagStatus, classes.textContainer, classes.textValor, theme, transferencias])

    return (
        <Box className={classes.listBottomCard}>
            <Button variant='outlined'
                color='primary'
                className={classes.showBtn}
                fullWidth
                onClick={() => setHide(prev => !prev)}
            >
                <ExpandIcon tipo='BUTTON' />
                {hide ? 'Mostrar Status' : 'Esconder Status'}
            </Button>
            <Box className={classes.items}>
                {returnStatusInfo}
            </Box>
        </Box>
    )
}

